import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './App';
import { registerServiceWorker, watchInstallPrompt } from './lib/pwa';
import { installTouchHelpers } from './lib/touch';
import { AppProviders } from './state/providers';
import './styles/prototype.css';
import './styles/layout.css';
import './styles/buttons.css';
import './styles/otp.css';
import './styles/app.css';
import './styles/assistant.css';
import './styles/touch.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

watchInstallPrompt();
installTouchHelpers();
// SW jen v produkčním buildu – ve vývoji by cachoval Vite moduly
if (import.meta.env.PROD) registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProviders>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AppProviders>
    </QueryClientProvider>
  </StrictMode>,
);
